import { Price } from '../price';

export enum ReturnRequestAction {
  Received = 'RECEIVED',
  ReceivedByCustomerInPostOfficeFlow = 'RECEIVED_BY_CUSTOMER_IN_POST_OFFICE_FLOW',
  Inconsistency = 'INCONSISTENCY',
}

export enum ReturnRequestStatus {
  Ready = 'READY',
  RefundInProgress = 'REFUND_IN_PROGRESS',
  Refunded = 'REFUNDED',
  Canceled = 'CANCELED',
  Open = 'OPEN',
}

export const RETURN_REQUEST_STATUS_OPTIONS = [
  { label: 'Pendente', value: ReturnRequestStatus.Open },
  { label: 'Estornado', value: ReturnRequestStatus.Refunded },
];

export type Resume = {
  quantity: number;
  totalPrice: Price;
};

export type ReturnRequestItem = {
  chargeId: string;
  consignmentCode: string;
  createdDate: number;
  isAvailableToRefund: boolean;
  protocol: string;
  status: string;
  value: Price;
};

export type ReturnRequestListResponse = {
  results: ReturnRequestItem[];
  pagination: {
    count: number;
    totalCount: number;
    page: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
  };
  sorts: any[];
};

export type ReturnRequestListParams = {
  startDate?: number;
  endDate?: number;
  statuses?: string;
  currentPage?: number;
  pageSize?: number;
};

interface Product {
  description: string;
  entryNumber: number;
  price: Price;
  sku: string;
  status: string;
}

interface ConsignmentDetails {
  chargeId: string;
  code: string;
  deliveryCost: {
    price: Price;
    refundedPrice: Price;
  };
  products: Product[];
  recipient: string;
  refundedPrice: Price;
  status: string;
  totalPrice: Price;
}

export interface ReturnRequestDetails {
  chargeId: string;
  consignmentCode: string;
  createdDate: number;
  isAvailableToRefund: boolean;
  protocol: string;
  status: string;
  value: Price;
}

export interface ConsignmentAndReturnResponse {
  consignments: ConsignmentDetails[];
  createdDate: number;
  modifiedDate: number;
  installments: number;
  orderCode: string;
  paymentMethod: string;
  returnRequests: ReturnRequestDetails[];
  totalPrice: Price;
}

export interface ConsignmentAndReturnParams {
  orderCode?: string;
  protocol?: string;
  chargeId?: string;
}
